<template>
  <section class="sotial-networks">
    <!-- <a v-if="!loading && content.settings.social.whatsapp" :href="!loading ? content.settings.social.whatsapp : ''" class="mx-2">
      <ZWhatsappSvg />
    </a> -->
    <a
      v-if="!loading && content.settings.social.facebook"
      :href="!loading ? content.settings.social.facebook : ''"
      class="ml-3"
    >
      <svg
        width="17"
        height="17"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
      >
        <path
          d="M256.064,0h-0.128C114.784,0,0,114.816,0,256c0,56,18.048,107.904,48.736,150.048l-31.904,95.104l98.4-31.456
                                C155.712,496.512,204,512,256.064,512C397.216,512,512,397.152,512,256S397.216,0,256.064,0z M405.024,361.504
                                c-6.176,17.44-30.688,31.904-50.24,36.128c-13.376,2.848-30.848,5.12-89.664-19.264C189.888,347.2,141.44,270.752,137.664,265.792
                                c-3.616-4.96-30.4-40.48-30.4-77.216s18.656-54.624,26.176-62.304c6.176-6.304,16.384-9.184,26.176-9.184
                                c3.168,0,6.016,0.16,8.576,0.288c7.52,0.32,11.296,0.768,16.256,12.64c6.176,14.88,21.216,51.616,23.008,55.392
                                c1.824,3.776,3.648,8.896,1.088,13.856c-2.4,5.12-4.512,7.392-8.288,11.744c-3.776,4.352-7.36,7.68-11.136,12.352
                                c-3.456,4.064-7.36,8.416-3.008,15.936c4.352,7.36,19.392,31.904,41.536,51.616c28.576,25.44,51.744,33.568,60.032,37.024
                                c6.176,2.56,13.536,1.952,18.048-2.848c5.728-6.176,12.8-16.416,20-26.496c5.12-7.232,11.584-8.128,18.368-5.568
                                c6.912,2.4,43.488,20.48,51.008,24.224c7.52,3.776,12.48,5.568,14.304,8.736C411.2,329.152,411.2,344.032,405.024,361.504z"
          fill="#bbb"
        />
      </svg>
    </a>
    <a
      v-if="!loading && content.settings.social.instagram"
      :href="!loading ? content.settings.social.instagram : ''"
      class="ml-3"
    >
      <svg
        width="25"
        height="25"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
      >
        <path
          d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160
                                C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48
                                h192c61.76,0,112,50.24,112,112V352z"
          fill="#bbb"
        />
        <path
          d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336
                                c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"
          fill="#bbb"
        />
        <circle cx="393.6" cy="118.4" r="17.056" fill="#bbb" />
      </svg>
    </a>
    <a
      v-if="!loading && content.settings.social.twitter"
      :href="!loading ? content.settings.social.twitter : ''"
      class="ml-2"
    >
      <svg
        width="17"
        height="17"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
      >
        <path
          d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016
                                c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992
                                c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056
                                c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152
                                c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792
                                c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44
                                C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568
                                C480.224,136.96,497.728,118.496,512,97.248z"
          fill="#bbb"
        />
      </svg>
    </a>
    <a
      v-if="!loading && content.settings.social.telegram"
      :href="!loading ? content.settings.social.telegram : ''"
      class="ml-3"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        class="bi bi-telegram"
        viewBox="0 0 16 16"
      >
        <path
          fill="#bbb"
          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z"
        />
      </svg>
    </a>
    <a
      v-if="!loading && content.settings.social.facebook"
      :href="!loading ? content.settings.social.facebook : ''"
      class="ml-2"
    >
      <svg
        width="15"
        height="15"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
      >
        <path
          d="M448,0H64C28.704,0,0,28.704,0,64v384c0,35.296,28.704,64,64,64h192V336h-64v-80h64v-64c0-53.024,42.976-96,96-96h64v80
                                h-32c-17.664,0-32-1.664-32,16v64h80l-32,80h-48v176h96c35.296,0,64-28.704,64-64V64C512,28.704,483.296,0,448,0z"
          fill="#bbb"
        />
      </svg>
    </a>
    <a
      href="https://maps.app.goo.gl/ndxkWJimf2LZZM39A"
      target="_blank"
      rel="noopener noreferrer"
      class="map-link ml-3 d-md-none d-inline-block"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.895508 4.58873C0.895508 2.09711 2.97761 0.083252 5.4961 0.083252C8.02173 0.083252 10.1038 2.09711 10.1038 4.58873C10.1038 5.84426 9.64722 7.00987 8.89565 7.99787C8.06652 9.08765 7.04462 10.0372 5.89428 10.7825C5.63103 10.9547 5.39345 10.9677 5.10447 10.7825C3.94766 10.0372 2.92572 9.08765 2.1037 7.99787C1.35158 7.00987 0.895508 5.84426 0.895508 4.58873ZM3.97988 4.72902C3.97988 5.56367 4.66101 6.22017 5.4961 6.22017C6.33178 6.22017 7.01948 5.56367 7.01948 4.72902C7.01948 3.90081 6.33178 3.21237 5.4961 3.21237C4.66101 3.21237 3.97988 3.90081 3.97988 4.72902Z"
          fill="#bbb"
        />
      </svg>
    </a>
  </section>
</template>

<script>
import ZWhatsappSvg from "./ZWhatsappSvg";
export default {
  name: "SocialNetworks",
  components: { ZWhatsappSvg },
  computed: {
    content() {
      return this.$store.getters["front/getHomeData"];
    },
    loading() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },
};
</script>

<style scoped></style>
